import { Route, Routes } from 'react-router';

import PublicLayout from '@/modules/layout/Public';
import Error404Page from '@/modules/pages/404';
import AboutMePage from '@/modules/pages/AboutMe';
import CookBookPage from '@/modules/pages/CookBook';
import CookBookDetailPage from '@/modules/pages/CookBookDetail';
import GlagolEspanolPage from '@/modules/pages/GlagolEspanol';
import LanguageGate from '@/modules/routing/LanguageGate';

// Every page lives under its language, `/ru/cookbook`; LanguageGate puts one in front of a URL without it,
// so :lang is always a language here
const AppRoutes = () => (
    <LanguageGate>
        <Routes>
            <Route path=":lang" element={<PublicLayout/>}>
                <Route index element={<AboutMePage/>}/>
                <Route path="cookbook" element={<CookBookPage/>}/>
                <Route path="cookbook/:id" element={<CookBookDetailPage/>}/>
                <Route path="glagol_espanol" element={<GlagolEspanolPage/>}/>
                <Route path="*" element={<Error404Page/>}/>
            </Route>
        </Routes>
    </LanguageGate>
);

export default AppRoutes;
